import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { usePermissions } from '@/stores/usePermissions';
import { useAuthStore } from '@/stores/authStore';

export function permissionGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const authStore = useAuthStore();
  const { hasPermission } = usePermissions();

  const required = to.meta?.permissions;

  // Si la ruta NO requiere permisos → continua
  if (!required) return next();

  // Si no hay usuario logueado
  if (!authStore.user) return next('/');

  // Una sola cadena
  if (typeof required === 'string') {
    return hasPermission(required) ? next() : next('/403');
  }

  // Un array de permisos -> debe cumplir por lo menos uno
  if (Array.isArray(required)) {
    return required.some((p) => hasPermission(p))
      ? next()
      : next('/403');
  }

  next();
}
